import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Login } from "../pages/Login";
import { Register } from "../pages/Register";
import { Home } from "../pages/Home";
import { CourseDispOn } from "../pages/CourseDispOn";
import { CourseOpenList } from "../pages/CourseOpenList";
import { PerformanceCourseOn } from "../pages/PerformanceCourse";
import { AutorizarCourseOn } from "../pages/AutorizarCourse";
import { AtualizarPerfil } from "../pages/AtualizarPerfil";
import { NotFound } from "../components/NotFound";
import { PrivateRoute } from "./privateRoutes";

export const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/esat/sigecap" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route path="/esat/sigecap/painel" element={<Home />} />
          <Route path="/esat/sigecap/curso/meuscursos" element={<CourseDispOn />} />
          <Route path="/esat/sigecap/curso/disponiveis" element={<CourseOpenList />} />
          <Route path="/esat/sigecap/performance/visualizar" element={<PerformanceCourseOn />} />
          <Route path="/esat/sigecap/atualizar/perfil" element={<AtualizarPerfil />} />
          <Route path="/esat/sigecap/autorizar" element={<AutorizarCourseOn />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};
